const lunch = [
    {
        id: 1,
        name: 'A Set-Curry Choice (Chicken, DAL, Vegetable) : Aセット – カレー選択（チキン・ダール・ベジタブル',
        description: 'Choose from chicken, dal, or vegetable curry. Served with naan and side salad',
        price: '¥750'
    },
    {
        id: 2,
        name: 'B Set-Curry Choice (Seafood, Sag Mutton, DAL Ghosh) : Bセット – カレー選択（シーフード・サグマトン・ダールゴーシュト）',
        description: 'Choose from seafood, sag mutton, or dal ghosh curry. Served with naan, side salad and soft drink',
        price: '¥850'
    },
    {
        id: 3,
        name: 'Cheese Nan Set : チーズナンセット – カレー選択（バターチキン・ダール）',
        description: 'Cheese-filled naan set with your choice of butter chicken or dal curry, served with salad',
        price: '¥950'
    },
    {
        id: 4,
        name: 'Butter Chicken Curry Set : バターチキンカレーセット（ナン・サラダ・ソフトドリンク付き）',
        description: 'Creamy butter chicken curry served with naan, side salad, and a soft drink of your choice',
        price: '¥900'
    },
    {
        id: 5,
        name: 'Keema Curry Set : キーマカレーセット（ナン・サラダ・ソフトドリンク付き',
        description: 'Spiced minced meat curry served with naan, side salad, and a soft drink of your choice',
        price: '¥900'
    },
    {
        id: 5,
        description: '   All curries are available spiciness choice.',
        price: 'Mild   --  Medium  --   Hot'
    }
];

export default lunch;